export default class VoidCell extends HTMLElement {
    constructor() {
        super();
        this.innerHTML += '-';
        this.style.textAlign = 'center';
        this.style.width = '100%';
        this.style.display = 'block';
    }
  }
  
  customElements.define('void-cell', VoidCell);
  